import EmptyView from './EmptyView.view';

export default EmptyView;
